if (!customElements.get('deployer-cart-drawer')) {
    customElements.define(
        'deployer-cart-drawer',
        class DeployerCartDrawer extends HTMLElement {
            constructor() {
                super();

                // Flags pour éviter les rafraîchissements multiples
                this.isRefreshing = false;
                this.quantityChangeTimeout = null;

                // Bound handlers pour pouvoir les retirer
                this.boundHandleRefresh = this.handleRefresh.bind(this);
                this.boundHandleQuickAdd = this.handleQuickAdd.bind(this);

                this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

                // Connecte le panier à l'icône du panier
                this.setHeaderCartIconAccessibility();

                // Connecte le panier aux formulaires des pages produit
                this.setProductFormCompatibility(this);

                document.addEventListener('quickadd:loaded', this.boundHandleQuickAdd);

                // Initialiser les listeners avec délégation d'événements
                this.initDelegatedListeners();

                // Écouter l'événement de rafraîchissement
                document.addEventListener('deployer-cart-drawer:refresh', this.boundHandleRefresh);
            }

            disconnectedCallback() {
                document.removeEventListener('deployer-cart-drawer:refresh', this.boundHandleRefresh);
                document.removeEventListener('quickadd:loaded', this.boundHandleQuickAdd);
            }

            handleRefresh() {
                this.refreshCart();
            }

            handleQuickAdd() {
                this.setProductFormCompatibility(this);
            }

            // Utiliser la délégation d'événements pour éviter de perdre les listeners
            initDelegatedListeners() {
                // Overlay click
                this.addEventListener('click', (event) => {
                    // Fermer si clic sur overlay
                    if (event.target.classList.contains('deployer-cart-drawer__overlay')) {
                        this.close();
                        return;
                    }

                    // Bouton checkout
                    if (event.target.closest('#DeployerCartDrawer-Checkout')) {
                        event.target.closest('#DeployerCartDrawer-Checkout').classList.add('deployer-button--is-loading');
                        return;
                    }

                    // Bouton supprimer
                    const removeButton = event.target.closest('.deployer-cart-drawer__item-remove');
                    if (removeButton) {
                        event.preventDefault();
                        this.updateLineItemQuantity(removeButton.dataset.index, 0);
                        return;
                    }

                    // Boutons de quantité (+/-)
                    const quantityButton = event.target.closest('.deployer-cart-drawer__item-quantity-button:not([disabled])');
                    if (quantityButton) {
                        const cartItem = quantityButton.closest('.deployer-cart-drawer__item');
                        const superiorElement = cartItem?.querySelector('deployer-superior-offer');
                        const quantityInput = cartItem?.querySelector('.deployer-cart-drawer__item-quantity-input');

                        if (superiorElement) {
                            superiorElement.handleClick(event);
                        } else if (quantityInput) {
                            this.onQuantityButtonClick(event, quantityInput);
                        }
                        return;
                    }
                });

                // Changement de quantité via input
                this.addEventListener('change', (event) => {
                    const quantityInput = event.target.closest('.deployer-cart-drawer__item-quantity-input');
                    if (quantityInput) {
                        this.updateLineItemQuantity(quantityInput.dataset.index, quantityInput.value);
                    }
                });
            }

            // Garder pour compatibilité mais ne plus l'utiliser pour les listeners principaux
            connectCartItemsListeners() {
                // Méthode conservée pour compatibilité mais les listeners sont maintenant délégués
            }

            setHeaderCartIconAccessibility() {
                if (window.deployerAdapter.cartIcon) {
                    window.deployerAdapter.cartIcon.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.open();
                    });
                } else {
                    console.error('Icône du panier non trouvée');
                }
            }

            // Intercepte les ajouts au panier pour les envoyer à la méthode de rendu du panier
            setProductFormCompatibility(cartDrawer) {
                document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
                    form.querySelectorAll('[name="add"]').forEach((button) => {
                        button.addEventListener('click', function (event) {
                            event.preventDefault(), event.stopPropagation();

                            if (button.getAttribute('aria-disabled') === 'true') return;

                            button.setAttribute('aria-disabled', true);
                            button.classList.add('deployer-button--is-loading');
                            // if (button.querySelector('.loading__spinner')) button.querySelector('.loading__spinner').classList.remove('hidden');

                            const config = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
                            };
                            config.headers['X-Requested-With'] = 'XMLHttpRequest';
                            delete config.headers['Content-Type'];

                            const formData = new FormData(button.closest('form'));

                            formData.append(
                                'sections',
                                document
                                    .querySelector('deployer-cart-drawer')
                                    .getSectionsToRender()
                                    .map((section) => section.section)
                            );
                            formData.append('sections_url', window.location.pathname);

                            config.body = formData;

                            fetch('/cart/add', config)
                                .then((response) => response.json())
                                .then((response) => {
                                    if (response.status) {
                                        document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: response.description } }));
                                        return;
                                    }
                                    document.querySelector('deployer-cart-drawer').renderCartContents(response);
                                    document.dispatchEvent(new CustomEvent('cart-product:add'));
                                })
                                .catch((e) => {
                                    console.error(e);
                                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: "Erreur d'ajout au panier" } }));
                                })
                                .finally(() => {
                                    // if (button.querySelector('.loading__spinner')) button.querySelector('.loading__spinner').classList.add('hidden');
                                    button.classList.remove('deployer-button--is-loading');
                                    button.removeAttribute('aria-disabled');
                                    if (cartDrawer.classList.contains('deployer-cart-drawer--empty')) cartDrawer.classList.remove('deployer-cart-drawer--empty');
                                });
                        });
                    });
                });
            }

            open() {
                // here the animation doesn't seem to always get triggered. A timeout seem to help
                setTimeout(() => {
                    this.classList.add('animate', 'active');
                });
                window.deployerAdapter.containerToAvoidScroll.classList.add(window.deployerAdapter.classToAvoidScroll);
            }

            close() {
                this.classList.remove('active');
                window.deployerAdapter.containerToAvoidScroll.classList.remove(window.deployerAdapter.classToAvoidScroll);
                if (window.deployerAdapter.containerToAvoidScroll.style.overflow === 'hidden') {
                    window.deployerAdapter.containerToAvoidScroll.style.overflow = 'auto';
                }
            }

            getSectionsToRender() {
                const cartContainerSectionId = window.deployerAdapter.cartIcon.closest('.shopify-section').id.replace('shopify-section-', '');
                return [
                    {
                        id: 'deployer-cart-drawer',
                        section: 'deployer-cart-drawer',
                        selector: '.deployer-cart-drawer__inner',
                    },
                    {
                        id: cartContainerSectionId,
                        section: cartContainerSectionId,
                        selector: window.deployerAdapter.cartIconSelector,
                    },
                ];
            }

            renderCartContents(parsedState) {
                this.querySelector('.deployer-cart-drawer__inner').classList.contains('deployer-cart-drawer--empty') && this.querySelector('.deployer-cart-drawer__inner').classList.remove('deployer-cart-drawer--empty');

                this.getSectionsToRender().forEach((section) => {
                    const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                    const temporaryDom = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
                    if (temporaryDom.querySelector(section.selector)) {
                        sectionElement.innerHTML = temporaryDom.querySelector(section.selector).innerHTML;
                    } else {
                        sectionElement.innerHTML = temporaryDom.querySelector('.shopify-section').innerHTML;
                    }
                });

                setTimeout(() => {
                    this.open();
                    this.connectCartItemsListeners();
                });
            }

            refreshCart() {
                // Éviter les rafraîchissements multiples simultanés
                if (this.isRefreshing) return;
                this.isRefreshing = true;

                // Ne met pas à jour la pastille de l'icone du panier. Mise à jour à prévoir
                fetch(window.Shopify.routes.root + '?sections=deployer-cart-drawer')
                    .then((res) => res.json())
                    .then((data) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data['deployer-cart-drawer'], 'text/html');
                        const newContent = doc.querySelector('deployer-cart-drawer');

                        if (newContent) {
                            this.innerHTML = newContent.innerHTML;

                            // Mettre à jour la classe empty si nécessaire
                            if (newContent.classList.contains('deployer-cart-drawer--empty')) {
                                this.classList.add('deployer-cart-drawer--empty');
                            } else {
                                this.classList.remove('deployer-cart-drawer--empty');
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Erreur lors du rafraîchissement du panier:', error);
                    })
                    .finally(() => {
                        // Réinitialiser le flag après un court délai pour éviter les rafraîchissements trop rapides
                        setTimeout(() => {
                            this.isRefreshing = false;
                        }, 100);
                    });
            }

            onQuantityButtonClick(event, cart_item_input) {
                event.preventDefault();
                const previousValue = cart_item_input.value;
                const button = event.target.closest('.deployer-cart-drawer__item-quantity-button');

                if (button) {
                    button.name === 'plus' ? cart_item_input.stepUp() : cart_item_input.stepDown();
                }

                if (previousValue !== cart_item_input.value) {
                    // Utiliser le timeout de l'instance pour éviter les fuites
                    if (this.quantityChangeTimeout) {
                        clearTimeout(this.quantityChangeTimeout);
                    }
                    this.quantityChangeTimeout = setTimeout(() => {
                        this.updateLineItemQuantity(cart_item_input.dataset.index, cart_item_input.value);
                        this.quantityChangeTimeout = null;
                    }, 300);
                }
            }

            updateLineItemQuantity(line, quantity) {
                this.enableLoading(line);

                const body = JSON.stringify({
                    line,
                    quantity,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: window.location.pathname,
                });

                fetch('/cart/change', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json` }, ...{ body } })
                    .then((response) => {
                        return response.text();
                    })
                    .then((state) => {
                        const parsedState = JSON.parse(state);
                        const quantityElement = document.getElementById(`DeployerCartDrawer-Quantity-${line}`);

                        if (parsedState.errors) {
                            quantityElement.value = quantityElement.getAttribute('value');
                            this.setLineItemError(line, parsedState.errors);
                            return;
                        }

                        document.dispatchEvent(new CustomEvent('cart-product:change'));

                        this.classList.toggle('deployer-cart-drawer--empty', parsedState.item_count === 0);

                        this.renderCartContents(parsedState);
                    })
                    .catch((e) => {
                        console.error(e);
                        this.setCartError('Une erreur est survenue lors de l’actualisation de votre panier. Veuillez réessayer.');
                        this.disableLoading(line);
                    })
                    .finally(() => {
                        this.disableLoading(line);
                    });
            }

            setLineItemError(line, message) {
                if (document.querySelector('deployer-toast-notification')) {
                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
                    return;
                }
                const lineItemError = document.getElementById(`DeployerCartDrawer-LineItemError-${line}`);
                if (lineItemError) lineItemError.querySelector('.deployer-cart-drawer__item-error-text').innerHTML = message;
            }

            setCartError(message) {
                if (document.querySelector('deployer-toast-notification')) {
                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
                    return;
                }
                document.getElementById('DeployerCartDrawer-CartErrors').textContent = message;
            }

            enableLoading(line) {
                const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
                mainCartItems.classList.add('deployer-cart-drawer__items--disabled');
                const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
                cartDrawerItemElements.forEach((overlay) => overlay.classList.remove('hidden'));
                document.querySelector('.deployer-cart-drawer__totals-value').classList.add('deployer-loading');
                if (document.querySelector('.deployer-cart-drawer__reductions-value')) {
                    document.querySelector('.deployer-cart-drawer__reductions-value').classList.add('deployer-loading');
                }
                document.querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`).classList.add('deployer-loading');
            }

            disableLoading(line) {
                const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
                mainCartItems.classList.remove('deployer-cart-drawer__items--disabled');
                const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
                cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
                document.querySelector('.deployer-cart-drawer__totals-value').classList.remove('deployer-loading');
                if (document.querySelector('.deployer-cart-drawer__reductions-value')) {
                    document.querySelector('.deployer-cart-drawer__reductions-value').classList.remove('deployer-loading');
                }
                if (document.querySelector(`#DeployerCartDrawer-Item-${line}`)) {
                    document.querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`).classList.remove('deployer-loading');
                }
            }
        }
    );
}

class DeployerCartNote extends HTMLElement {
    constructor() {
        super();

        let inputTimeout;
        this.addEventListener('input', (event) => {
            clearTimeout(inputTimeout);
            inputTimeout = setTimeout(() => {
                const body = JSON.stringify({ note: event.target.value });
                fetch('/cart/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: body,
                });
            }, 300);
        });
    }
}

if (!customElements.get('deployer-cart-note')) customElements.define('deployer-cart-note', DeployerCartNote);

// Countdown timer

class DeployerCountdown extends HTMLElement {
    constructor() {
        super();
        this.countdownDuration = 0;
        this.redirectOnTimeout = false;
        this.countdownTimer = null;
        this.countdownEndTime = 0;
        this.countdownInterval = null;
    }

    connectedCallback() {
        this.countdownDuration = parseInt(this.dataset.duration) * 60;
        this.redirectOnTimeout = this.dataset.redirect === 'true';
        this.countdownTimer = this.querySelector('#countdown-timer');
        this.countdownEndTime = new Date().getTime() + this.countdownDuration * 1000;

        this.updateCountdown = this.updateCountdown.bind(this);
        this.countdownInterval = setInterval(this.updateCountdown, 1000);
        this.updateCountdown();
    }

    updateCountdown() {
        var now = new Date().getTime();
        var distance = this.countdownEndTime - now;
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            clearInterval(this.countdownInterval);
            this.countdownTimer.innerHTML = "Le temps est écoulé.";
            if (this.redirectOnTimeout) {
                window.location.href = "/checkout";
            }
        } else {
            this.countdownTimer.innerHTML = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        }
    }
}

customElements.define('deployer-countdown', DeployerCountdown);


// Cross sells

class DeployerCartCrossSell extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const layoutInline = JSON.parse(this.querySelector('.cross-sells-products').getAttribute('data-layout-inline'));

        if (layoutInline) {
            const elem = this.querySelector('.slider-layout');

            const observer = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentRect.width > 0) {
                        observer.unobserve(elem);
                        this.initFlickity(elem);
                    }
                }
            });

            observer.observe(elem);
        }

        this.querySelectorAll('.quick-add').forEach(button => {
            button.addEventListener('click', this.addToCart.bind(this));
        });
    }

    initFlickity(elem) {
        const flkty = new Flickity(elem, {
            cellAlign: 'left',
            contain: false,
            pageDots: false,
            percentPosition: true,
            draggable: true
        });

        flkty.resize();
    }

    addToCart(event) {
        const productId = event.target.getAttribute('data-product-id');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: productId,
                quantity: 1
            })
        })
            .then(response => response.json())
            .then(() => {
                document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }
}

customElements.define('deployer-cart-cross-sell', DeployerCartCrossSell);


class DeployerSuperiorOffer extends HTMLElement {
    constructor() {
        super();

        this.superiorVariantId = this.dataset.superiorVariantId;
        this.currentVariantId = this.dataset.currentVariantId;
        this.lineItemKey = this.dataset.lineItemKey;
        this.lineItemQtn = this.dataset.lineItemQtn;
        this.button = this.querySelector('.btn');
    }

    connectedCallback() {
        if (this.button)
            this.button.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(e) {
        e.preventDefault();

        if (this.superiorVariantId && this.currentVariantId && this.lineItemKey) {
            if (this.button.querySelector('.loading__spinner')) {
                this.button.classList.add('loading');
                this.button.querySelector('.loading__spinner').classList.remove('hidden');
            }
            try {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: this.lineItemKey,
                        quantity: this.lineItemQtn - 1
                    })
                });

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: this.superiorVariantId, quantity: 1 }]
                    })
                });

                document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));

            } catch (error) {
                console.error('Error upgrading variant:', error);
            }
        }
    }
}

customElements.define('deployer-superior-offer', DeployerSuperiorOffer);